import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { IntegrationCredentialService } from 'src/app/services/integration-credentials.service';
import { IntegrationCredentials } from 'src/app/shared/models/general/integration-credentials';

@Component({
  selector: 'app-workbench',
  templateUrl: './workbench.component.html',
  styleUrls: ['./workbench.component.scss'],
})
export class WorkbenchComponent implements OnInit {
  constructor(private credentialService: IntegrationCredentialService) {}

  successFul: boolean = false;
  pageError: HttpErrorResponse;
  showError: boolean = false;

  integrationCredentials: IntegrationCredentials[] = [];

  editMode = false;
  editedCredential: IntegrationCredentials | null;

  editableUserName: boolean;

  editField(credential: IntegrationCredentials, fieldName: string) {
    this.editableUserName = credential.integrationName === 'CFS-BankBalance' || credential.integrationName === 'CFS-General';

    this.editMode = true;
    this.editedCredential = credential;
  }

  saveRecord(credential: IntegrationCredentials) {
    credential.error = null;
    credential.recentlyUpdated = false;
    credential.isUpdating = true;
    this.editMode = false;
    this.editedCredential = null;
    this.credentialService.UpdateCredential(credential).subscribe({
      next: (response) => {
        this.handleRecordUpdate(credential, response);
      },
      error: (error) => {
        credential.isUpdating = false;
        credential.error = error;
        this.pageError = credential.error;
      },
    });
  }

  private handleRecordUpdate(credential: IntegrationCredentials, updatedCredential: IntegrationCredentials) {
    credential.password = updatedCredential.password;
    credential.isEnabled = updatedCredential.isEnabled;
    credential.refreshCount = updatedCredential.refreshCount;

    credential.recentlyUpdated = true;
    credential.updateSuccess = true;
    credential.isUpdating = false;
    setTimeout(() => {
      credential.recentlyUpdated = false;
    }, 3000);
  }

  ngOnInit(): void {
    this.GetAllIntegrationCredentials();
  }

  GetAllIntegrationCredentials() {
    this.credentialService.GetAll().subscribe({
      next: (response) => {
        this.integrationCredentials = response;
      },
      error: (error) => {
        alert('Error' + error);
      },
    });
  }
}
